import { MultiSelectDropDownInput } from '../inputs/dropdown/MultiSelectDropDownInput.tsx';
import styles from './Filter.module.scss';
import clsx from 'clsx';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Input } from '../inputs/Input.tsx';
import { mergeRefs } from 'react-merge-refs';

export interface FilterValue {
  value: string;
  localization: string;
}

type FilterComponentProps = {
  options: FilterValue[];
  selectedOptions?: string[];
  onValueChanged: (value: string[]) => void;
  placeholder: string;
  width?: number | 'auto';
  multiSelectClassName?: string;
  hasSearchFilter?: boolean;
};

export const Filter = (props: FilterComponentProps) => {
  const [selectedValues, setSelectedValues] = useState<FilterValue[]>(
    props.options.filter((value) =>
      props.selectedOptions?.includes(value.value),
    ) ?? [],
  );
  const selectedValuesRef = useRef<FilterValue[]>([]);

  useEffect(() => {
    selectedValuesRef.current = selectedValues;
  }, [selectedValues]);

  const inputRef = useRef<HTMLInputElement>(undefined!);

  const postfix = useMemo(() => getPostfix(selectedValues), [selectedValues]);

  return (
    <MultiSelectDropDownInput
      inputRef={inputRef}
      hideHeader={true}
      showResetFooter={true}
      options={props.options}
      placeholder={props.placeholder}
      itemSize={40}
      className={clsx(props.multiSelectClassName, styles.dropDownInput)}
      isOptionEqualToValue={(opt, val) => opt.value === val.value}
      getOptionLabel={'localization'}
      classes={{
        popper: styles.popper,
        option: styles.option,
      }}
      value={selectedValues}
      onValueChanged={(newValues) => setSelectedValues([...newValues])}
      hasSearchFilter={props.hasSearchFilter}
      onClose={() => {
        props.onValueChanged(selectedValuesRef.current.map((v) => v.value));
      }}
      renderInput={(data) => {
        const selectedValue = data.selectedValue as FilterValue[] | undefined;
        const value =
          selectedValue && selectedValue.length > 0
            ? selectedValue[0].localization
            : '';

        const valuePostfix = postfix === undefined ? '' : ' ' + postfix;

        return (
          <Input
            {...data}
            testId={'filter-input'}
            value={value + valuePostfix}
            onBlur={undefined}
            containerRef={mergeRefs([inputRef, data.containerRef as any])}
          />
        );
      }}
    />
  );
};

function getPostfix(selectedValues: FilterValue[]): string | undefined {
  if (selectedValues.length > 1) {
    return `(+${selectedValues.length - 1})`;
  }
  return undefined;
}
